import { useId } from "react";

interface MarkProps {
  className?: string;
}

export function LeisureMark({ className }: MarkProps) {
  const id = useId();
  const clipId = `leisure-clip-${id}`;

  return (
    <svg viewBox="0 0 100 100" className={className}>
      <clipPath id={clipId}>
        <circle cx="50" cy="50" r="45" />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <rect x="0" y="0" width="100" height="100" fill="transparent" />
        <path d="M -20 -20 L 120 120 M 0 -40 L 140 100 M -40 0 L 100 140 M -60 20 L 80 160 M 20 -60 L 160 80 M 40 -80 L 180 60" stroke="currentColor" strokeWidth="12" opacity="0.2" />
      </g>
      <circle cx="50" cy="50" r="45" fill="none" stroke="currentColor" strokeWidth="3" />
      <text x="50" y="56" textAnchor="middle" fontFamily="'Cormorant Garamond', serif" fontSize="32" fontStyle="italic" fontWeight="bold" fill="currentColor">MH</text>
    </svg>
  );
}
